/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Discardconfirm3Inputs */

const en_coinvestments_dataroom_discardconfirm3 = /** @type {(inputs: Coinvestments_Dataroom_Discardconfirm3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All unsaved changes will be lost. Are you sure you want to discard?`)
};

/**
* | output |
* | --- |
* | "All unsaved changes will be lost. Are you sure you want to discard?" |
*
* @param {Coinvestments_Dataroom_Discardconfirm3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_discardconfirm3 = /** @type {((inputs?: Coinvestments_Dataroom_Discardconfirm3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Discardconfirm3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_discardconfirm3(inputs)
});
export { coinvestments_dataroom_discardconfirm3 as "coInvestments_dataRoom_discardConfirm" }